import React from 'react';
import { BaseAddonCategoryXlsProvider } from 'contexts/base-addon-category-xls.context';
import BaseAddonCategoryXlsContent from './content';

const BaseAddonCategoryXlsLayout = () => {
  return (
    <BaseAddonCategoryXlsProvider>
      <BaseAddonCategoryXlsContent />
    </BaseAddonCategoryXlsProvider>
  );
};

export default BaseAddonCategoryXlsLayout;
